import axios from 'axios'
const BASE_API_URL = process.env.REACT_APP_API_URL
//=====================Item URL======================
export const GET_ALL_Vehicle_MakeList = `${BASE_API_URL}/VehicleMake/VehicleMake_GetList` //Get List
export const CREATE_Vehicle_Make = `${BASE_API_URL}/VehicleMake/VehicleMake_AddDetails` //Add
export const UPDATE_Vehicle_Make = `${BASE_API_URL}/VehicleMake/VehicleMake_UpdateDetails` //Update
export const UPDATE_Vehicle_Make_BY_Vehicle_Make_ID = `${BASE_API_URL}/VehicleMake/VehicleMake_GetBy_VehicleMakeID` //Grt By Id
export const IS_ACTIVE_Vehicle_Make = `${BASE_API_URL}/VehicleMake/VehicleMake_Updates_Isactive` //Iss Active
export const DELETE_Vehicle_Make = `${BASE_API_URL}/VehicleMake/VehicleMake_Delete_Details` //Delete

// ============================================================================
export function GetVehicleMakeListAPI() {
  return axios.get(GET_ALL_Vehicle_MakeList)
}
// ============================================================================
export function CreateVehicleMakeAPI(
  vehicleMakeName: string,
  photoPath: string,
  isActive: boolean,
  createBy: number,
  ipAddress: string
) {
  return axios.post(CREATE_Vehicle_Make, {
    vehicleMakeName,
    photoPath,
    isActive,
    createBy,
    ipAddress,
  })
}
// ============================================================================
export function UpdateVehicleMakeAPI(
  vehicleMakeID: number,
  vehicleMakeName: string,
  photoPath: string,
  isActive: boolean,
  updateBy: number,
  ipAddress: string
) {
  return axios.post(UPDATE_Vehicle_Make, {
    vehicleMakeID,
    vehicleMakeName,
    photoPath,
    isActive,
    updateBy,
    ipAddress,
  })
}
// ============================================================================
export function GetVehicleMakeByVehicleMakeIDAPI(vehicleMakeID: number) {
  return axios.post(UPDATE_Vehicle_Make_BY_Vehicle_Make_ID, {vehicleMakeID})
}
// ============================================================================
export function DeleteVehicleMakeAPI(vehicleMakeID: number) {
  return axios.post(DELETE_Vehicle_Make, {vehicleMakeID})
}
// ============================================================================
export function IsActiveVehicleMakeAPI(vehicleMakeID: number, isActive: boolean) {
  return axios.post(IS_ACTIVE_Vehicle_Make, {vehicleMakeID, isActive})
}
